// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"7b970fd9","480":"7b970fd9"}[chunkId] + ".chunk.css";
};